<template>
  <div class="cooperation-page__title">
    <div v-if="isEmployer" class="cooperation-page__title-main">{{$tCooperation('Making a new employee')}}</div>
    <div v-else class="cooperation-page__title-main">{{$tCooperation('Job application')}}</div>

    <div class="cooperation-page__title-right">
      <div>{{$tCooperation('for vacancy')}}</div>
      <router-link-modified :to="{name: 'vacancy', params: {
                vacancyId: vacancy.vacancy_slug
              }}"
                   class="inline-link">
        <span>{{ vacancy.title }}</span>&nbsp;
        <BaseSvg
                name="ico-arrow-light"
                class="_arrow"
        />
      </router-link-modified>
    </div>
  </div>
</template>

<script>
  export default {
    props: ['vacancy', 'isEmployer']
  };
</script>
